module.exports = __webpack_public_path__ + "static/simple-installer-fb31a79bb19ef48cf3bdc474f6171d74.gif";